import axios from "axios";
import { Dispatch } from "react";
import { Action } from "../contexts/DataContext";
import Price from "../models/Price";
import { Blog } from "../models/Blog";
import { FAQ } from "../models/Faq";
import { HomePage } from "../models/HomePage";
import { SubscribePage } from "../models/SubscribePage";
import { InquirePage } from "../models/InquirePage";
import { GlobalData } from "../models/GlobalData";
import { ContactFormField } from "../models/ContactFormField";
import { InquiryFormData } from "../models/InquiryFormData";
import { CarouselImages } from "../models/CarouselImages";
import Review from "../models/Review";
import { PortfolioKeyword } from "../models/PortfolioKeyword";
import { PortfolioAlbum } from "../models/PortfolioAlbum";

const baseUrl = "https://api.alamodeimage.com";

export const fetchFaqs = async (dispatch: Dispatch<Action>): Promise<void> => {
  try {
    const response: FAQ[] = (
      await axios.get<any>(`${baseUrl}/api/faqs?sort=sortOrder:asc&sort=id:asc`)
    ).data.data as FAQ[];
    dispatch({ type: "SET_FAQS", payload: response });
  } catch (error) {
    console.error("Error fetching FAQs:", error);
  }
};

export const fetchAbout = async (dispatch: Dispatch<Action>): Promise<void> => {
  try {
    const response = await axios.get<any>(`${baseUrl}/api/about`);
    dispatch({ type: "SET_ABOUT", payload: response.data });
  } catch (error) {
    console.error("Error fetching About:", error);
  }
};

export const fetchHomePage = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: HomePage = (
      await axios.get<any>(`${baseUrl}/api/homepage?populate=*`)
    ).data.data as HomePage;
    dispatch({ type: "SET_HOME_PAGE", payload: response });
  } catch (error) {
    console.error("Error fetching About:", error);
  }
};

export const fetchSubscribePage = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: SubscribePage = (
      await axios.get<any>(`${baseUrl}/api/subscribe-page?populate=*`)
    ).data.data as SubscribePage;

    dispatch({ type: "SET_SUBSCRIBE_PAGE", payload: response });
  } catch (error) {
    console.error("Error fetching Subscribe Page:", error);
  }
};

export const fetchInquirePage = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: InquirePage = (
      await axios.get<any>(`${baseUrl}/api/inquire-page?populate=*`)
    ).data.data as InquirePage;

    dispatch({ type: "SET_INQUIRE_PAGE", payload: response });
  } catch (error) {
    console.error("Error fetching Subscribe Page:", error);
  }
};

export const fetchContactFormFields = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: ContactFormField[] = (
      await axios.get<any>(`${baseUrl}/api/contact-form-fields`)
    ).data.data as ContactFormField[];

    dispatch({ type: "SET_CONTACT_FORM_FIELDS", payload: response });
  } catch (error) {
    console.error("Error fetching Contact Form Fields:", error);
  }
};

export const fetchGlobalData = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: GlobalData = (
      await axios.get<any>(`${baseUrl}/api/global?populate=*`)
    ).data.data as GlobalData;

    dispatch({ type: "SET_GLOBAL_DATA", payload: response });
  } catch (error) {
    console.error("Error fetching Subscribe Page:", error);
  }
};

export const fetchWelcomeImage = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response = await axios.get<any>(`${baseUrl}/api/welcomeImage`);
    dispatch({ type: "SET_WELCOME_IMAGE", payload: response.data });
  } catch (error) {
    console.error("Error fetching Welcome Image:", error);
  }
};

export const fetchPricing = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: Price[] = (
      await axios.get<any>(
        `${baseUrl}/api/prices?populate=*&sort=DisplayOrder:asc&sort=id:asc`
      )
    ).data.data as Price[];

    dispatch({ type: "SET_PRICES", payload: response });
  } catch (error) {
    console.error("Error fetching Pricing:", error);
  }
};

export const fetchReviews = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: Review[] = (
      await axios.get<any>(`${baseUrl}/api/reviews?populate=*`)
    ).data.data as Review[];

    dispatch({ type: "SET_REVIEWS", payload: response });
  } catch (error) {
    console.error("Error fetching Pricing:", error);
  }
};

export const fetchBlogs = async (dispatch: Dispatch<Action>): Promise<void> => {
  try {
    const response: Blog[] = (
      await axios.get<any>(`${baseUrl}/api/blogs?populate=*`)
    ).data.data as Blog[];

    dispatch({ type: "SET_BLOGS", payload: response });
  } catch (error) {
    console.error("Error fetching Blogs:", error);
  }
};

export const fetchBlog = async (
  blog_url_path: string
): Promise<Blog | undefined> => {
  try {
    return (
      await axios.get<any>(
        `${baseUrl}/api/blogs?filters[blog_url_path][$eq]=${blog_url_path}`
      )
    ).data.data[0] as Blog;
  } catch (error) {
    console.error("Error fetching Blog:", error);
  }
};

export const fetchCarouselPortraitImages = async (
  dispatch: Dispatch<Action>
): Promise<CarouselImages | undefined> => {
  try {
    const response: CarouselImages = (
      await axios.get<any>(`${baseUrl}/api/carousel-portrait?populate=*`)
    ).data.data as CarouselImages;

    dispatch({ type: "SET_CAROUSEL_PORTRAIT_IMAGES", payload: response });
    return response;
  } catch (error) {
    console.error("Error fetching CarouselImages:", error);
  }
};
export const fetchCarouselLandscapeImages = async (
  dispatch: Dispatch<Action>
): Promise<CarouselImages | undefined> => {
  try {
    const response: CarouselImages = (
      await axios.get<any>(`${baseUrl}/api/carousel-landscape?populate=*`)
    ).data.data as CarouselImages;

    dispatch({ type: "SET_CAROUSEL_LANDSCAPE_IMAGES", payload: response });
    return response;
  } catch (error) {
    console.error("Error fetching CarouselImages:", error);
  }
};

export const fetchPortfolioKeywords = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response: PortfolioKeyword[] = (
      await axios.get<any>(`${baseUrl}/api/portfolio-keywords?populate=*`)
    ).data.data as PortfolioKeyword[];

    dispatch({ type: "SET_PORTFOLIO_KEYWORDS", payload: response });
  } catch (error) {
    console.error("Error fetching Portfolio Keywords:", error);
  }
}

export const fetchPortfolioAlbums = async (
  dispatch: Dispatch<Action>
): Promise<void> => {
  try {
    const response = await axios.get<any>(
      `${baseUrl}/api/portfolio-albums?populate=*`
    );
    // Strapi wraps results in a `data` property; keep only the array
    const albums = response.data?.data;

    //parse keywords for each album
    let keywords: PortfolioKeyword[] = [];
    albums.forEach((album: PortfolioAlbum) => {
      keywords.push(...(album.portfolio_keywords));
    });
    dispatch({ type: "SET_PORTFOLIO_KEYWORDS", payload: keywords });
    dispatch({ type: "SET_PORTFOLIO_ALBUMS", payload: albums });
  } catch (error) {
    console.error("Error fetching Portfolios:", error);
  }
};

export const subscribeUser = async (
  email: string
): Promise<boolean | string> => {
  try {
    const response = await axios.post<any>(`${baseUrl}/api/subscribers`, {
      data: { Email: email },
    });
    if (response.data?.data?.id) {
      return true;
    } else {
      return false;
    }
  } catch (error: any) {
    if (error.response.data.error.message === "This attribute must be unique") {
      return "This email has already been registered.";
    }
    return false;
  }
};

export const sendUserInquiry = async (
  data: InquiryFormData
): Promise<boolean> => {
  try {
    const response = await axios.post<any>(
      `${baseUrl}/api/contact-form-messages`,
      {
        data,
      }
    );
    if (response.data?.data?.id) {
      return true;
    } else {
      return false;
    }
  } catch (error: any) {
    return false;
  }
};
